/**
 * Acel Cortex admin wordmark — `acel·cortex admin` lowercase, green
 * interpunct between acel + cortex, " admin" small-caps in mono after.
 * Per design system rules: never capitalize, never replace the dot.
 */
export function Wordmark() {
  return (
    <span
      style={{
        fontFamily: 'var(--font-sans)',
        fontWeight: 600,
        fontSize: 'var(--fs-h4)',
        color: 'var(--ink)',
        letterSpacing: '-0.01em',
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 'var(--space-2)',
      }}
    >
      <span>
        acel<span style={{ color: 'var(--green)' }}>·</span>cortex
      </span>
      <span
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--fs-mono-sm)',
          letterSpacing: 'var(--tracking-mono)',
          textTransform: 'uppercase',
          color: 'var(--muted)',
        }}
      >
        admin
      </span>
    </span>
  );
}
